import React from 'react';
import PropTypes from 'prop-types';

import Button from 'relements/build/esm/ui/button';
import Text from 'relements/build/esm/ui/text';

// Components
import FAQUpload from '../FAQUpload';

import './BodyHeader.scss';

const BodyHeader = (props) => {
  const { orderedNodes, isSelfServe, onSave, edited } = props;

  return (
    <div className="general-nodes-body-header">
      <div className="general-nodes-body-text">
        {orderedNodes.length !== 0 && (
          <>
            <Text variant="h1.semi-bold">FAQs</Text>
            <Text variant="body.lg">
              Steps that answer general questions about the Bot domain.
            </Text>
          </>
        )}
      </div>
      <div
        className={`general-nodes-header-actions ${
          orderedNodes.length !== 0 ? 'general-nodes-header-actions-sticky' : ''
        } ${
          isSelfServe ? 'general-nodes-header-actions-sticky-selfserver' : ''
        }`}
      >
        {orderedNodes.length !== 0 && <FAQUpload isEmptyList={false} />}
        <Button
          type={Button.TYPES.PRIMARY}
          themed
          onClick={onSave}
          variant={edited ? 'primary' : 'disabled'}
          disabled={!edited}
          className={edited ? '' : 'saveButton'}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

BodyHeader.propTypes = {
  orderedNodes: PropTypes.arrayOf(PropTypes.object),
  isSelfServe: PropTypes.bool,
  onSave: PropTypes.func,
  onUploadQA: PropTypes.func,
  edited: PropTypes.bool,
};

export default BodyHeader;
